import {mergeDeepObject} from "./_util";
import Inputmask from "inputmask/dist/inputmask";

const VGMask = {
	init: function () {
		let _this = this,
			$selector = document.querySelectorAll('[data-mask]');

		if ($selector.length) {
			for (let i = 1; i <= $selector.length; i++) {
				let mask = $selector[i - 1].dataset.mask,
					format, opts = {};

				switch (mask) {
					case 'phone':
						format = $selector[i - 1].dataset.format || '8 (999) 999-99-99';
						opts = mergeDeepObject({
							clearIncomplete: true,
							showMaskOnHover: true,
							onBeforeMask: function (pastedValue, opts) {
								return _this.normalize_phone(pastedValue)
							},
						}, opts);
						break;
				}

				if (format) {
					let im = new Inputmask(format, opts);
					im.mask($selector[i - 1]);
				}
			}
		}
	},

	normalize_phone: function (val) {
		return val.replace(new RegExp(/\D/, 'g'), '').split('').reverse().slice(0, 10).reverse().join('');
	}
};

function onReady() {
	VGMask.init();
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGMask;
